var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-form-field pr-0",class:[`col-${_vm.col}`, `fs-${_vm.fontSize}`, { '-border': _vm.border }, { 'font-weight-bold': _vm.bold }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }